import React from "react";
import Icon from "../ui/Icon";
import { industries } from "../../data/industries";

/**
 * "Industries We Serve" content block (right column of the home split section).
 */
const Industries = () => (
  <div>
    <h2 className="mb-6 font-headline-lg text-headline-lg uppercase text-primary">
      Industries We Serve
    </h2>
    <div className="mt-12 grid grid-cols-2 gap-4">
      {industries.map((industry) => (
        <div
          key={industry.label}
          className="group flex cursor-pointer flex-col items-center justify-center rounded-lg border border-outline-variant/30 bg-surface-container-lowest p-6 text-center shadow-sm transition-colors hover:border-primary-container"
        >
          <Icon
            name={industry.icon}
            className="mb-3 text-3xl text-primary transition-transform group-hover:scale-110"
          />
          <span className="font-label-sm text-label-sm font-bold text-on-surface">
            {industry.label}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default Industries;
